/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { Component } from "react";
import { connect } from "react-redux";
import { store } from "../../reduxStore/store";
import { notificationNumber } from "../../reduxStore/actions/commonAction";
import Label from "../../components/label";
import ICButton from "../../components/button";
import NotificationList from "../../containers/NotificationList";
import { readAllNotification } from "../../apiRoutes";
import Model from "../../components/modal";
import MakeAPICall from "../../apiCalls/common";
import NotificationTabs from "./NotificationTabs";

class NotificationPage extends Component {
  constructor() {
    super();
    this.state = {
      errorModelOpen: false,
      errorModelBody: "",
      errorModelTitle: "",
      clear: false,
      apiCall: "",
      activeTab: 0
    };
  }

  clearAllNotifications = () => {
    let apiCallParam = {
      reqType: "PUT",
      reqURL: readAllNotification,
      dataObj: {
        status: 2
      },
      params: {
        limit: 0,
        skip: 0
      },
      headers: {},
      successCallback: res => {
        this.setState({
          clear: true,
          errorModelOpen: true,
          errorModelTitle: "Instant Consult",
          errorModelBody: "Notifications Moved to History"
        });
        this.notificationNumber(res.data.data.unReadCount);

        setTimeout(() => {
          this.setState({
            clear: false
          });
        }, 3000);
      },
      failureCallback: err => {
        console.log("Got the error : ", err);
      },
      showPopUp: false
    };
    this.setState({ apiCall: apiCallParam });
  };

  notificationNumber = async (data) => {
    await this.props.notificationNumber({
      totalNotification: data
    });
  }

  closeErrorModel = () => {
    this.setState({ errorModelOpen: false });
  };

  componentAPICall = data => {
    this.setState({ apiCall: data });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    const isViewHistory = this.props.location && this.props.location.state && this.props.location.state.viewHistory ? 1 : 0;
    this.setState({
      activeTab: isViewHistory
    })
  }

  // componentWillUnmount() {
  //   this.setState({
  //     activeTab: 0
  //   })
  // }

  render() {
    return (
      <div className="row rounded p-3 notification-page">
        {/* Top Filters */}
        <div className="col-sm-3 p-3">
          <Label title="Notifications" className="big" />
        </div>

        <div className="col-sm-2 offset-sm-7 pt-3 pr-0 text-right">
          <ICButton
            title="Mark All Done"
            className="gray small gray-outline"
            clickEvent={this.clearAllNotifications}
          />
        </div>

        <div className="w-100 border-bottom"></div>

        <div className="col-sm-12 mt-3 pl-0 pr-0 custom-li">
          <NotificationTabs clear={this.state.clear}
            makeAPICall={this.componentAPICall}
            updateNotificationNumber={this.notificationNumber}
            activeTab={this.state.activeTab}
          />
        </div>

        {/* <div className="col-sm-12 custom-li mt-3 pl-0 pr-0">
          <NotificationList
            clear={this.state.clear}
            makeAPICall={this.componentAPICall}
            updateNotificationNumber={this.notificationNumber}
          />
        </div> */}

        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />

        {/* Error Model */}
        <Model
          openModal={this.state.errorModelOpen}
          modalBodyContent={this.state.errorModelBody}
          okayText="Okay"
          cancelText="Okay"
          title={this.state.errorModelTitle}
          useOneButton={true}
          okayEvent={this.closeErrorModel}
          cancelEvent={this.closeErrorModel}
        />
      </div>
    );
  }
}

// export default NotificationPage;
const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  notificationNumber: (data) => dispatch(notificationNumber(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationPage);

